/**
 * @prettier
 */
import type { DriverArrivesAtStoreTime } from 'src/constants/DriverArrivesAtStoreTime';
import { OrderType, OrderTypes } from 'src/constants/OrderType';
import { PickupTimeType, PickupTimeTypes } from 'src/constants/PickupTimeType';
import type { TimeZone } from 'src/constants/TimeZone';
import { translate } from 'src/i18n/translate';
import { formatPickupTime } from 'src/utils/transform/formatPickupTime';

export function translatePickupTime({ pickupTimeType, pickupTime, orderType, driverArrivesAtStoreTime, preparationTime, timeZone }: Props): string {
    if (pickupTimeType === PickupTimeTypes.ASAP) {
        if (orderType === OrderTypes.DELIVERY_ORDER) {
            return translate('Estimated delivery @minutes min', { minutes: translate(`DriverArrivesAtStoreTimes.${driverArrivesAtStoreTime ?? 'DEFAULT'}`) });
        }
        return translate('Ready in @minutes min').replace('@minutes', `${preparationTime}-${preparationTime + 5}`);
    }
    if (pickupTimeType === PickupTimeTypes.PLANNED) {
        return formatPickupTime(pickupTime, timeZone);
    }
    return translate('Select time for pre-ordering');
}

type Props = {
    pickupTimeType: PickupTimeType;
    pickupTime: string;
    preparationTime: number;
    timeZone: TimeZone;
    orderType: OrderType;
    drivingDuration?: number;
    driverArrivesAtStoreTime?: DriverArrivesAtStoreTime;
};
